<template>
  <el-card
    class="account-remittance-not-account business-handling my-card"
    :body-style="cardBody"
  >
    <el-page-header @back="$router.go(-1)" :title="$t('Back')">
      <template slot="content"
        ><span style="font-size:14px"
          >{{ $t("depositBusiness") }} / {{ $t("deposit") }}</span
        ></template
      >
    </el-page-header>
    <div class="form-container">
      <el-divider content-position="left">
        <el-form
          inline
          ref="queryForm"
          :model="queryForm"
          :rules="rules"
          style="height:45px;overflow:hidden;"
        >
          <el-form-item
            :label="$t('accountInfo')"
            prop="param"
            style="margin-bottom:0"
          >
            <phone-input
              v-model="queryForm.param"
              size="mini"
              @phone-input="onParamInput"
            />
          </el-form-item>
          <el-form-item style="margin-bottom:0">
            <el-button
              size="mini"
              type="primary"
              @click="onQuery('queryForm')"
              >{{ $t("queryAccountInfo") }}</el-button
            >
          </el-form-item>
        </el-form>
      </el-divider>
      <!-- 存款信息 -->
      <el-form
        v-if="remitterInfo"
        ref="remittanceForm"
        :model="remittanceForm"
        :rules="rules"
        label-position="top"
      >
        <el-input
          type="hidden"
          size="medium"
          v-model="remitterInfo.businessCode"
          disabled
        ></el-input>
        <el-row :gutter="20">
          <el-col :md="8" :lg="6" :xl="4">
            <el-form-item :label="$t('firstName')">
              <el-input
                size="medium"
                v-model="remitterInfo.firstName"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :md="8" :lg="6" :xl="4">
            <el-form-item :label="$t('lastName')">
              <el-input
                size="medium"
                v-model="remitterInfo.lastName"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :md="8" :lg="6" :xl="4">
            <el-form-item :label="$t('phone')">
              <el-input
                size="medium"
                v-model="remitterInfo.phone"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :md="8" :lg="6" :xl="4">
            <el-form-item :label="$t('idNumber')">
              <el-input
                size="medium"
                v-model="remitterInfo.idCard"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :md="8" :lg="6" :xl="4">
            <el-form-item :label="$t('accountAmount')">
              <el-input
                size="medium"
                v-model="remitterInfo.accountAmount"
                disabled
              >
                <template slot="prepend"
                  ><i
                    class="iconfont iconruishifalang"
                    style="font-size:14px"
                  ></i>
                </template>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :md="8" :lg="6" :xl="4">
            <el-form-item :label="$t('account')">
              <el-input
                size="medium"
                v-model="remitterInfo.cardNo"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-divider content-position="left">{{ $t("depositInfo") }}</el-divider>
        <el-row :gutter="20">
          <el-col :md="8" :lg="6" :xl="4">
            <el-form-item :label="$t('depositAmount')" prop="amount">
              <el-input
                size="medium"
                v-model="remittanceForm.amount"
                @blur="calculateServiceCharge"
                :disabled="isCompute"
                maxlength="11"
                @input="
                  remittanceForm.amount = remittanceForm.amount
                    .replace(/[^0-9]/g, '')
                    .formatMoney(0, ' ')
                "
              >
                <template slot="prepend"
                  ><i
                    class="iconfont iconruishifalang"
                    style="font-size:14px"
                  ></i>
                </template>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :md="8" :lg="6" :xl="4">
            <el-form-item
              :label="
                $t('serviceCharge') +
                  ' ' +
                  (isCompute ? $t('calculating') + '……' : '')
              "
              prop="serviceChargeAmount"
            >
              <el-input
                size="medium"
                v-model="remittanceForm.serviceChargeAmount"
                disabled
                :placeholder="
                  $t('AfterEnteringTheAmountItWillBAutomaticallyCalculated')
                "
              >
                <template slot="prepend"
                  ><i
                    class="iconfont iconruishifalang"
                    style="font-size:14px"
                  ></i>
                </template>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :md="8" :lg="6" :xl="4">
            <el-form-item :label="$t('Service fee discount')" prop="coupon">
              <el-input
                size="medium"
                v-model="remittanceForm.coupon"
                type="number"
              >
                <template slot="prepend"
                  ><i
                    class="iconfont iconruishifalang"
                    style="font-size:14px"
                  ></i>
                </template>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :md="8" :lg="6" :xl="4">
            <transaction-tax-display
              businessCode="40"
              :transaction-amount="remittanceForm.amount"
            ></transaction-tax-display>
          </el-col>
        </el-row>
        <el-divider content-position="left">{{
          $t("depositorInfo")
        }}</el-divider>
        <el-row :gutter="20">
          <el-col :md="8" :lg="6" :xl="4">
            <el-form-item :label="$t('phone')" prop="DepositorPhoneNo">
              <phone-input
                v-model="remittanceForm.DepositorPhoneNo"
                @phone-input="handlePhoneInput"
              />
            </el-form-item>
          </el-col>
          <el-col :md="8" :lg="6" :xl="4">
            <el-form-item :label="$t('firstName')" prop="DepositorFirstName">
              <el-input
                size="medium"
                v-model="remittanceForm.DepositorFirstName"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :md="8" :lg="6" :xl="4">
            <el-form-item :label="$t('lastName')" prop="DepositorLastName">
              <el-input
                size="medium"
                v-model="remittanceForm.DepositorLastName"
              ></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-col :span="12">
              <el-form-item :label="$t('remark')">
                <el-input
                  size="medium"
                  type="textarea"
                  v-model="remittanceForm.remark"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="bottom-button" v-if="remitterInfo">
      <el-button
        v-if="!printParam"
        size="medium"
        :loading="isLoading"
        type="primary"
        @click="onSubmit('remittanceForm')"
        >{{ $t("submit") }}</el-button
      >
      <el-button v-else size="medium" @click="printVisible = true">{{
        $t("printrRceipt")
      }}</el-button>
    </div>

    <el-dialog
      :title="$t('printrRceipt')"
      :visible.sync="printVisible"
      width="500px"
      :modal-append-to-body="false"
      :destroy-on-close="true"
      :show-close="false"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
    >
      <print-credentials-deposit
        :param="printParam"
        :isClosePrint.sync="printVisible"
      />
    </el-dialog>
  </el-card>
</template>

<script>
import printCredentialsDeposit from "@/components/printCredentialsDeposit";
//import printCredentialsModern from "@/components/printCredentialsModern";
import PhoneInput from "@/components/PhoneInput";
import customer from "@/api/customer";
import transactionInfo from "@/api/transactionInfo";
import TransactionTaxDisplay from "@/components/TransactionTaxDisplay";
import business from "@/api/business";
import { debounce } from "lodash";
import transactionDetails from "@/api/transactionDetails";

//
export default {
  components: {
    printCredentialsDeposit,
    TransactionTaxDisplay,
    PhoneInput,
  },
  data() {
    return {
      isLoading: false,

      /**查询存款人信息 */
      queryForm: {},
      /**存款人信息 */
      remitterInfo: null,
      /**存款信息 */
      remittanceForm: { coupon: 0 },
      /**收款人信息 */
      payeeForm: {},

      isCompute: false,

      printVisible: false,
      printParam: null,
    };
  },

  computed: {
    cascader() {
      return this.$store.state.format.cascader;
    },
    cardBody() {
      return this.$store.state.style.cardBody;
    },
    countryTree() {
      return this.$store.state.globalParameter.countryTree;
    },
    rules() {
      return {
        param: [
          {
            required: true,
            trigger: "blur",
            validator: (rule, value, callback) => {
              if (!value || value.trim().length < 4) {
                callback(new Error(this.$t("requiredFields")));
              } else {
                callback();
              }
            },
          },
        ],
        serviceChargeAmount: [
          {
            required: true,
            message: this.$t("requiredFields"),
            trigger: "blur",
          },
        ],
        amount: [
          {
            required: true,
            message: this.$t("requiredFields"),
            trigger: "blur",
          },
        ],
        DepositorFirstName: [
          {
            required: true,
            message: this.$t("requiredFields"),
            trigger: "blur",
          },
        ],
        DepositorLastName: [
          {
            required: true,
            message: this.$t("requiredFields"),
            trigger: "blur",
          },
        ],
        DepositorPhoneNo: [
          {
            required: true,
            message: this.$t("requiredFields"),
            trigger: "blur",
          },
        ],
      };
    },
  },
  watch: {
    printVisible(val) {
      if (!val && this.printParam) {
        this.$router.replace({ name: "businessHandling" }).then(() => {
          this.$router.go(0);
        });
      }
    },
    /**手续费优惠输入金额后计算优惠后的手续费 */
    "remittanceForm.coupon"(newValue) {
      /**优惠手续费金额不能是负数 */
      if (newValue < 0) {
        this.remittanceForm.coupon = 0;
        return;
      }
      /**优惠后手续费不能是负数 */
      if (this.remittanceForm.purposeBefore - this.remittanceForm.coupon < 0) {
        this.remittanceForm.coupon = 0;
        return;
      }

      this.$set(
        this.remittanceForm,
        "serviceChargeAmount",
        this.remittanceForm.purposeBefore - this.remittanceForm.coupon,
      );
    },
    "remittanceForm.amount"(newValue) {
      if (newValue < 0) this.remittanceForm.amount = 0;
    },
  },
  methods: {
    calculateServiceCharge() {
      let _this = this;
      if (!_this.remittanceForm.amount) {
        _this.$set(_this.remittanceForm, "serviceChargeAmount", undefined);
        return;
      }
      _this.isCompute = true;
      business.serviceChargeCompute({
        param: {
          amount: _this.remittanceForm.amount,
          businessCode: _this.$route.params.code,
        },
        success: (res) => {
          setTimeout(() => {
            _this.isCompute = false;
            if (res.code != 200) _this.$message.warning(_this.$t(res.msg));

            /**手续费 */
            _this.$set(
              _this.remittanceForm,
              "serviceChargeAmount",
              res.data || 0,
            );
            /**手续费优惠前 */
            _this.$set(_this.remittanceForm, "purposeBefore", res.data || 0);
          }, 500);
        },
      });
    },
    onParamInput() {},
    /*onQuery(refName) {
      let _this = this;
      this.$refs[refName].validate((valid) => {
        if (valid) {
          let p = {};
          if (_this[refName].param.length === 15)
            p.cardNo = _this[refName].param;
          else p.phone = _this[refName].param;

          customer.getByAccountOrPhone({
            param: p,
            success: (res) => {
              if (res.code != 200) {
                _this.$message.warning(_this.$t(res.msg));
                return;
              }
              _this.remitterInfo = {
                businessCode: _this.$route.params.code,
                firstName: res.data.name,
                lastName: res.data.surname,
                phone: res.data.phoneNo,
                idCard: res.data.idCard,
                accountAmount: res.data.accountAmount,
                cardNo: res.data.cardNo,
                cardId: res.data.cardId,
              };
            },
          });
        } else return false;
      });
    },
    */
    onQuery(refName) {
      this.$refs[refName].validate((valid) => {
        if (!valid) return false;
        const param = this.queryForm.param || "";
        const p = /^\d{15}$/.test(param) ? { cardNo: param } : { phone: param };
        customer.getByAccountOrPhone({
          param: p,
          success: (res) => {
            if (res.code != 200) {
              this.$message.warning(this.$t(res.msg));
              return;
            }
            this.remitterInfo = {
              businessCode: this.$route.params.code,
              firstName: res.data.name,
              lastName: res.data.surname,
              phone: res.data.phoneNo,
              idCard: res.data.idCard,
              accountAmount: res.data.accountAmount,
              cardNo: res.data.cardNo,
              cardId: res.data.cardId,
            };
          },
        });
      });
    },
    handlePhoneInput: debounce(function() {
      const phone = this.remittanceForm.DepositorPhoneNo || "";
      if (phone.length < 10) {
        this.$set(this.remittanceForm, "DepositorFirstName", "");
        this.$set(this.remittanceForm, "DepositorLastName", "");
        return;
      }
      this.getRemitterRecords("remittanceForm");
    }, 200),

    getRemitterRecords(refName) {
      let _this = this;
      let p = {};
      p.phone = _this[refName].DepositorPhoneNo;

      transactionDetails.getByPhoneAndIdCard({
        param: p,
        success: (res) => {
          if (res.code == 200) {
            if (Array.isArray(res.data) && res.data.length > 0) {
              const firstTransaction = res.data[0];

              // Update form fields reactively

              this.$set(
                this.remittanceForm,
                "DepositorFirstName",
                firstTransaction.name,
              );
              this.$set(
                this.remittanceForm,
                "DepositorLastName",
                firstTransaction.surname,
              );

              //console.log("Data ", firstTransaction.name, " ", firstTransaction.post)
            } else {
              // Update form fields reactively
              this.$set(this.remittanceForm, "DepositorFirstName", "");
              this.$set(this.remittanceForm, "DepositorLastName", "");

              _this.$message.warning(_this.$t("no data"));
            }
          } else {
            // Update form fields reactively
            this.$set(this.remittanceForm, "DepositorFirstName", "");
            this.$set(this.remittanceForm, "DepositorLastName", "");
            //this.$set(this.remittanceForm, "DepositorPhone", "");

            _this.$message.warning(_this.$t(res.msg));
          }
        },
      });
    },

    onSubmit(refName) {
      let _this = this;
      _this.$refs[refName].validate((valid) => {
        if (!valid) return false;
        _this.isLoading = true;

        let p = Object.assign(_this[refName], _this.remitterInfo);

        transactionInfo.customerDeposit({
          param: p,
          success: (res) => {
            if (res.code == 200) {
              _this.$message.success(_this.$t("operateSuccessfully"));
              _this.$set(_this, "printParam", res.data);
              _this.$set(_this, "printVisible", true);
            } else {
              _this.$message.warning(
                _this.$t(res.msg || _this.$t("operationFailure")),
              );
            }
            _this.isLoading = false;
          },
          failing: (err) => {
            _this.isLoading = false;
            console.error("customerDeposit failing:", err);
            _this.$message.error(_this.$t("Server error, please try again"));
          },
        });
      });
    },
  },
  mounted() {},
};
</script>

<style lang="less" scoped>
.account-remittance-not-account.business-handling {
  height: 100%;
  width: 100%;
  .el-card__body {
    position: relative;
    .form-container {
      position: absolute;
      top: 60px;
      bottom: 80px;
      left: 20px;
      right: 0;
      padding-right: 20px;
      overflow: auto;
    }
  }
  .el-form {
    height: auto;
  }
}
</style>
